import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';

import Box from '../box/box.jsx';
import Modal from '../modal/modal.jsx';
import styles from './rb-serial-connection-modal.css';


const RbSerialConnectionModal = props => (
    <Modal
        className={styles.modalContent}
        contentLabel={
            <FormattedMessage
                defaultMessage="USB Connection"
                description=""
                id="rb.gui.serialConnectionModal.usbConnection"
            />
        }
        onRequestClose={props.onCancel}
    >
        <Box className={styles.body}>
            <Box className={styles.flexWrapper}>
                <Box className={styles.editorWrapper}>
                    <Box>
                        <select
                            className={styles.customSelect}
                            value={props.selectValue}
                            onChange={props.onChange}
                        >
                            {
                                props.ports.length ? (
                                    props.ports
                                        .map(
                                            item => (
                                                <option
                                                    key={item.comName}
                                                    value={item.comName}
                                                >
                                                    {item.comName}
                                                </option>
                                            )
                                        )
                                ) : (
                                    <option
                                        disabled
                                        value={props.selectValue}
                                    >
                                        <FormattedMessage
                                            defaultMessage="Choose"
                                            description=""
                                            id="rb.gui.serialConnectionModal.choose"
                                        />
                                    </option>
                                )

                            }
                        </select>
                    </Box>
                    <Box className={styles.buttonRow}>
                        <button
                            className={styles.connectButton}
                            type="button"
                            onClick={props.onConnect}
                        >
                            <FormattedMessage
                                defaultMessage="Connect"
                                description=""
                                id="rb.gui.serialConnectionModal.connect"
                            />
                        </button>
                    </Box>
                </Box>
            </Box>
        </Box>
    </Modal>
);

RbSerialConnectionModal.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onConnect: PropTypes.func.isRequired,
    ports: PropTypes.arrayOf(PropTypes.object),
    selectValue: PropTypes.string.isRequired
    
};

export default RbSerialConnectionModal;
